import axios from 'axios';

// const baseURL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';
const baseURL = 'https://katibabkd.humanrights.or.tz';
const axiosInstance = axios.create({ baseURL });

const refreshTokens = async () => {
    const refreshToken = JSON.parse(localStorage.getItem('refreshToken') || null);

    if (!refreshToken) {
        console.warn('[Auth] No refresh token available - forcing logout');
        localStorage.removeItem('accessToken');
        window.location.reload();
        return Promise.reject(new Error('No refresh token'));
    }

    // console.log('[Auth] Attempting token refresh...');
    try {
        const response = await axiosInstance.post('/refresh-token', { refreshToken });
        // console.log('[Auth] Token refreshed successfully:', response.data);

        localStorage.setItem('accessToken', JSON.stringify(response.data.accessToken));
        return response.data.accessToken;
    } catch (error) {
        // console.error('[Auth] Token refresh failed:', error.response ? error.response.data : error.message);
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken'); // Ensure it's cleared
        window.location.reload();
        throw error;
    }
};

// Request Interceptor
axiosInstance.interceptors.request.use(
    (config) => {
        const accessToken = JSON.parse(localStorage.getItem('accessToken'));

        // console.log(`[Request] ${config.method.toUpperCase()} ${config.url}`);
        // console.log(`[Request] Checking accessToken:`,  accessToken);

        if (accessToken) {
            // console.log('[Request] Using access token:', accessToken);
            config.headers['Authorization'] = `Bearer ${accessToken}`;
        } else {
            // console.warn('[Request] No access token found! Would trigger reload here.');
            // Comment out reload to debug manually
            // window.location.reload();
        }
        return config;
    },
    (error) => {
        console.error('[Request Error]', error);
        return Promise.reject(error);
    }
);


// Response Interceptor
axiosInstance.interceptors.response.use(
    (response) => {
        // console.log(`[Response] ${response.config.url}`, response.data);
        return response;
    },
    async (error) => {
        const originalRequest = error.config;

        // console.error('[Response Error]', error.response ? error.response.data : error.message);

        // Unauthorized (401) - Handle Token Refresh
        if (error?.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;
            // console.warn('[Auth] 401 Unauthorized - Trying token refresh');

            try {
                const newAccessToken = await refreshTokens();
                originalRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;
                // console.log('[Auth] Retrying request with new access token');
                return axiosInstance(originalRequest);
            } catch (refreshError) {
                // console.error('[Auth] Refresh failed - forcing logout', refreshError);
                return Promise.reject(refreshError);
            }
        }

        // Forbidden (403) - Token is invalid or expired
        if (error?.response?.status === 403) {
            console.warn('[Auth] 403 Forbidden - Invalid token detected');
           // localStorage.removeItem('accessToken');
            //localStorage.removeItem('refreshToken');
            //window.location.reload();
        }

        return Promise.reject(error);
    }
);

export default axiosInstance;
